export function updateState(state, consents) {
  for (const key in consents) {
    state.value[key] = consents[key];
  }
}
